/* =========================================================
   Product Page — Clean JS (variant-safe sticky bar)
   ========================================================= */

$(document).ready(function () {
  /* ------------------------------
   * Product page custom accordion
   * ------------------------------ */
  $(".Product_Data_Tabs .Collapsible__Button").on("click", function () {
    let $parent = $(this).closest(".Collapsible");
    $parent
      .siblings(".Collapsible")
      .removeClass("open")
      .find(".Collapsible__Content")
      .slideUp();

    if ($parent.hasClass("open")) {
      $parent.removeClass("open").find(".Collapsible__Content").slideUp();
    } else {
      $parent.addClass("open").find(".Collapsible__Content").slideDown();
    }
  });

  function moveIntoAccordion(nodes, $accordionContent) {
    if (!nodes || !nodes.length) {
      $accordionContent && $accordionContent.remove();
      return;
    }
    for (var i = 0; i < nodes.length; i++) {
      // clone into accordion and remove from source
      $accordionContent[0].appendChild(nodes[i].cloneNode(true));
      nodes[i].remove();
    }
  }

  // Features
  moveIntoAccordion(
    document.querySelectorAll(".ProductMeta__Description .productIngredients"),
    $(".productIngredients_accordion .Collapsible__Content")
  );

  // Nutrition / S&R
  moveIntoAccordion(
    document.querySelectorAll(
      ".ProductMeta__Description .productNutritionInfo"
    ),
    $(".productNutritionInfo_accordion .Collapsible__Content")
  );

  // Taste notes
  moveIntoAccordion(
    document.querySelectorAll(".ProductMeta__Description .productTasteNotes"),
    $(".tasteNotes_accordion .Collapsible__Content")
  );

  // Serving suggestions
  moveIntoAccordion(
    document.querySelectorAll(
      ".ProductMeta__Description .productServingSuggestions"
    ),
    $(".servingSuggestions_accordion .Collapsible__Content")
  );

  // Remove empty accordions
  $(".Collapsible").each(function () {
    if ($(this).find(".Collapsible__Inner").html().trim() === "") {
      $(this).remove();
    }
  });

  /* ------------------------------
   * FAQs → collapsibles
   * ------------------------------ */
  let faqItems = document.querySelectorAll(".faqBlock .Item");
  faqItems.forEach(function (item) {
    let title = item.querySelector("h3")?.textContent || "";

    let desc = "";
    item.querySelectorAll("p, ul").forEach(function (el) {
      if (el.tagName === "P") desc += el.innerHTML + "<br><br>";
      if (el.tagName === "UL") desc += el.outerHTML;
    });

    let $wrap = $(`
      <div class="Collapsible">
        <button class="Collapsible__Button Heading u-h6" data-action="toggle-collapsible" aria-expanded="false">
          ${title}<span class="Collapsible__Plus"></span>
        </button>
        <div class="Collapsible__Inner">
          <div class="Collapsible__Content">${desc}</div>
        </div>
      </div>
    `);
    $(".faqBlock").append($wrap);
    item.remove();
  });

  // FAQ toggle
  $(".faqBlock").on("click", ".Collapsible__Button", function () {
    let $parent = $(this).closest(".Collapsible");
    $parent
      .siblings(".Collapsible")
      .removeClass("open")
      .find(".Collapsible__Content")
      .slideUp();

    if ($parent.hasClass("open")) {
      $parent.removeClass("open").find(".Collapsible__Content").slideUp();
    } else {
      $parent.addClass("open").find(".Collapsible__Content").slideDown();
    }
  });

  /* ------------------------------
   * Sticky Add-to-Cart visibility
   * ------------------------------ */
  $(".sticky-add-to-cart").hide();
  $(window).on("scroll", function () {
    if ($(this).scrollTop() > 800) {
      $(".sticky-add-to-cart").fadeIn();
    } else {
      $(".sticky-add-to-cart").fadeOut();
    }
  });
});

/* -----------------------------------
 * Related products slider (Flickity)
 * ----------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    if (!$("#related__products").length) return;

    var w = $(window).width();
    var childCount = $("#related__products").children().length;

    var needsSlider =
      (w > 992 && childCount > 4) ||
      (w > 589 && w <= 992 && childCount > 2) ||
      (w <= 589 && childCount > 1);

    if (needsSlider) {
      new Flickity("#related__products", {
        loop: true,
        wrapAround: true,
        cellAlign: "left",
        pageDots: true,
        initialIndex: 1,
        accessibility: true,
        autoPlay: false,
      });
      window.dispatchEvent(new Event("resize"));
    } else {
      $("#related__products").addClass("grid");
    }
  }, 5000);
});

/* =========================================================
   Variant & Sticky Bar — Single source of truth
   ========================================================= */
(function () {
  // ---------- Helpers ----------
  function q(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qa(sel, root) {
    return Array.from((root || document).querySelectorAll(sel));
  }
  function variantNodeById(id) {
    return q('.product_variant_data [data-variant_id="' + id + '"]');
  }
  function getCheckedVariantInput() {
    return (
      q('input[data-variant-id]:checked') ||
      q('input[data-variant-input]:checked') ||
      null
    );
  }
  function currentVariantId() {
    var input = getCheckedVariantInput();
    if (input) return input.dataset.variantId || input.value;

    var sel = q('select[name="id"]');
    if (sel && sel.value) return sel.value;

    // Fallback to first node in the hidden map
    var first = q(".product_variant_data [data-variant_id]");
    if (first) return first.getAttribute("data-variant_id");

    return null;
  }
  function labelTitleForVariant(id) {
    var input =
      q('input[data-variant-id="' + id + '"]') ||
      q('input[value="' + id + '"]');
    if (!input) {
      // Fallback to hidden map text
      var node = variantNodeById(id);
      return node ? node.textContent.trim() : "";
    }
    var label = input.nextElementSibling;
    if (!label) return "";
    var t = label.querySelector(".option_title");
    return (t ? t.textContent : label.textContent || "").trim();
  }

  // ---------- Sticky bar updater ----------
  function updateStickyFromVariantId(variantId) {
    if (!variantId) return;

    var node = variantNodeById(variantId);
    if (!node) return;

    var priceFmt = node.getAttribute("data-price-formate") || "";
    var compFmt = node.getAttribute("data-com-price-formate") || "";
    var priceRaw = parseFloat(node.getAttribute("data-price") || "0");
    var compRaw = parseFloat(node.getAttribute("data-com-price") || "0");

    // Sticky price elements (theme markup)
    var $sticky = $(".sticky-add-to-cart");
    var $price = $sticky.find(".product__price.sale-price");
    var $compare = $sticky.find(".product__price--compare");
    var $percentChip = $sticky.find(".option_percentage_off_price_bar");

    // Title
    var title = labelTitleForVariant(variantId);
    $(".product_variant_title").text(title);

    // Apply prices (selling first)
    if ($price.length) $price.text(priceFmt);

    if (compRaw && priceRaw && compRaw > priceRaw) {
      if ($compare.length) $compare.text(compFmt).show();
      var pct = Math.round(((compRaw - priceRaw) * 100) / compRaw);
      if ($percentChip.length) {
        $percentChip.addClass("available").text(pct + "% OFF");
      }
    } else {
      if ($compare.length) $compare.hide().text("");
      if ($percentChip.length) $percentChip.removeClass("available").text("");
    }

    // Keep sticky form select in sync (if present)
    var $stickySelect = $sticky.find(
      ".product-block-two select.product-single__variants"
    );
    if ($stickySelect.length) {
      $stickySelect.find("option").prop("selected", false);
      $stickySelect.find('option[value="' + variantId + '"]').prop("selected", true);
    }
  }

  // ---------- Bind listeners ----------
  function bindVariantListeners() {
    // Inputs (radio/buttons)
    document.addEventListener(
      "change",
      function (e) {
        if (
          e.target.matches("input[data-variant-id], input[data-variant-input]")
        ) {
          var id = e.target.dataset.variantId || e.target.value;
          updateStickyFromVariantId(id);
        }
      },
      true
    );

    // Labels (click bubbling)
    document.addEventListener(
      "click",
      function (e) {
        var lbl = e.target.closest(
          ".product_variant_section_main .variant-input-wrap label"
        );
        if (!lbl) return;
        // Find the linked input
        var input =
          lbl.previousElementSibling &&
          (lbl.previousElementSibling.matches("input[data-variant-id]") ||
            lbl.previousElementSibling.matches("input[data-variant-input]"))
            ? lbl.previousElementSibling
            : null;

        if (input) {
          var id = input.dataset.variantId || input.value;
          // mark visual selection
          $(".product_variant_section_main .variant-input").removeClass(
            "selected"
          );
          $(lbl).parents(".variant-input").addClass("selected");
          updateStickyFromVariantId(id);
        }
      },
      true
    );

    // Dropdowns
    document.addEventListener(
      "change",
      function (e) {
        if (e.target.matches('select[name="id"]')) {
          updateStickyFromVariantId(e.target.value);
        }
      },
      true
    );

    // Custom events some themes dispatch
    document.addEventListener("variant:changed", function (e) {
      var id =
        (e.detail && e.detail.id) ||
        (e.detail && e.detail.variant && e.detail.variant.id);
      if (id) updateStickyFromVariantId(String(id));
    });
  }

  // ---------- Init ----------
  document.addEventListener("DOMContentLoaded", function () {
    // IMPORTANT: Do NOT auto-click any “recommended” option.
    // Initialize from the *actual* selected variant.
    var id = currentVariantId();
    if (id) updateStickyFromVariantId(id);
    bindVariantListeners();
  });
})();

/* -----------------------------------
 * CTA bridges (sticky → native form)
 * ----------------------------------- */
$(document).ready(function () {
  // Mirror sticky buttons to native buttons
  $("button.sticky_buy_now_btn").on("click", function () {
    $(".product-single__form .shopify-payment-button .shopify-payment-button__button--unbranded").trigger("click");
  });
  $("button.sticky_add_to_cart_btn.add-to-cart--secondary").on("click", function () {
    $(".product-single__form .add-to-cart").trigger("click");
  });
});


/* -----------------------------------
 * Banner intersection toggle (unchanged)
 * ----------------------------------- */
document.addEventListener("DOMContentLoaded", () => {
  const banner = document.querySelector(".custom-banner");
  const body = document.body;
  if (!banner) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) body.classList.add("custom-atc-button");
        else body.classList.remove("custom-atc-button");
      });
    },
    { root: null, threshold: 0 }
  );

  observer.observe(banner);
});


